import React, { useState, useEffect } from 'react';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const ButtonContainer = styled.button`
	position: fixed;
	bottom: 32px;
	right: 32px;
	display: ${({  $visible }) => ( $visible ? 'flex' : 'none')};
	align-items: center;
	justify-content: center;
	width: 35px;
	height: 35px;
	background: ${({  $color }) =>  $color};
	border: 1px solid #f0f2e0;
	border-radius: 4px;
	cursor: pointer;
	opacity: 0.7;
	transition: opacity 0.3s, background 0.3s;
	z-index: 1;
	&:hover,
	&:focus {
		opacity: 1;
		outline: 2px solid #000;
		outline-offset: 2px;
	}
`;

const HIDDEN_PATHS = ['/', '/forgetpassword', '/suggestions/messenger'];

const getColorByPath = (path) => {
	if (path.startsWith('/partnership')) return '#9f003c';
	if (path.startsWith('/friendship')) return '#16738b';
	if (path.startsWith('/membership')) return '#063978';
	if (path.startsWith('/personal-details')) return '#464565';
	return '#59751d'; // default
};

const BackToTopButton = () => {
	const [visible, setVisible] = useState(false);
	const path = location.pathname;
	// check if page should hide
    const hidePage = HIDDEN_PATHS?.includes(path);
	// determine color
    const color = getColorByPath(path);
	const {t} = useTranslation();

	useEffect(() => {
		if (hidePage) return;

		const onScroll = () => setVisible(window.pageYOffset > 150);
		window.addEventListener('scroll', onScroll);
		return () => window.removeEventListener('scroll', onScroll);
	}, [hidePage]);

	return (
		<ButtonContainer
			$color={color}
			$visible={!hidePage && visible} 
			onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
			aria-label={(t('member.footer.back_to_top'))}
		>
			<FontAwesomeIcon icon={faArrowUp} style={{ color: '#fff' }} />
		</ButtonContainer>
	);
};

export default BackToTopButton;